export function schema_xlsx() {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			mode: {
				type: "string",
				title: "Mode",
				enum: ["csv vers xlsx", "xlsx vers csv"],
				default: "csv vers xlsx",
			},
			extension: {
				title: 'Extension',
				type: "string",
				enum: ["xlsx", "xlsm"],
				default: 'xlsx'
			},
			name_sheet: {
				title: 'Nom de l\'onglet',
				type: "string",
				default: 'Sheet'
			},
			image: {
				title: 'Image',
				type: "boolean",
				format: "checkbox"
			}
		},
	};
}
